import UploadPdf, { IUploadPdfProps } from '../uploadPdf'
import { useEffect, useState } from 'react'
import { useFileService } from 'services'

interface IProps extends IUploadPdfProps {
  pdfId?: number
}
const UploadPdfId = (props: IProps) => {
  const { getUrlFile } = useFileService()
  const { pdfId, ...resProps } = props
  const [urlImage, setImage] = useState('')

  const handleGetImage = () => {
    if (pdfId) {
      getUrlFile(pdfId).then((res) => {
        if (res._successfully) {
          setImage(res?.data?.public_access_url)
        }
      })
    }
  }

  useEffect(() => {
    handleGetImage()
  }, [pdfId])

  return <UploadPdf {...resProps} value={urlImage} />
}

export default UploadPdfId
